import { usePacingMetrics } from "../hooks/usePacingMetrics";
import { MetricCard } from "./MetricCard";

export function PacingStatsCard() {
    const { data, isLoading, isError } = usePacingMetrics();

    // Don't render anything if we can't fetch (e.g. no active session) or no data
    if (!isLoading && (isError || !data || data.totalSessions === 0)) return null;

    const onTargetPercent = data ? `${Math.round(data.onTargetRate * 100)}%` : "";

    return (
        <MetricCard
            isError={isError}
            isLoading={isLoading || !data}
            header={onTargetPercent}
            body="On-target call pace"
            updatedTime="Live"
        />
    );
}
